import axios from 'axios';
import Environment from '../../utils/Environment';

interface DoorStatusResponse {
  doorName: string;  // API returns doorName, not doorId
  status: string;
}

const getDoorStatuses = async (
  orgCode: string,
  doorIds: string[]
): Promise<Map<string, string>> => {
  try {
    const baseURL = Environment.getDoorStatusesAPI();
    console.log('Door Statuses API URL:', baseURL);
    if (!baseURL) {
      return new Map();
    }
    
    if (!orgCode || !doorIds || doorIds.length === 0) {
      return new Map();
    }
    const response = await axios.get<DoorStatusResponse[]>(baseURL, {
      params: {
        dcCode: orgCode,
        doorIds: doorIds.join(',')
      }
    });

    const statusMap = new Map<string, string>();
    
  
    if (response.data && Array.isArray(response.data)) {
      response.data.forEach((item: DoorStatusResponse) => {
        if (item.doorName) {
          statusMap.set(item.doorName, item.status || '');
        }
      });
    } else if (response.data && typeof response.data === 'object') {
     Object.entries(response.data).forEach(([doorId, status]) => {
        statusMap.set(doorId, status as string);
      });
    } else {
      console.warn('⚠️ Unexpected response format:', typeof response.data);
    }
    
    return statusMap;
  } catch (err: any) {
    if (err.response) {
    }
    if (err.request) {
      console.error('Request:', err.request);
    }
    if (err.config) {
      console.error('Request config:', {
        url: err.config.url,
        method: err.config.method,
        params: err.config.params
      });
    }
    return new Map();
  }
};

export default getDoorStatuses;
